import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import API_URL from "./config2";
import { toast } from "react-toastify";

export default function Footer() {
  const { t } = useTranslation("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubscribe = async (evt) => {
    evt.preventDefault();

    if (!email || !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      toast.error("Please enter a valid email address!");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: "Subscriber",
          email: email.trim(),
          phone: "N/A",
          interest: "newsletter",
          note: "",
          type: "newsletter",
        }),
      });

      const data = await res.json();

      if (data.success || data.alreadySubscribed) {
        toast.success(data.message || "Thanks for subscribing with us!");
        setEmail("");
        navigate("/thank-you");
      } else {
        toast.error(data.message || "Failed to subscribe. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Network error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Rest of your JSX remains exactly as before...
  return (
    <>
      <footer className="page-footer dark-color-footer" id="page-footer">
        <div
          className="overlay-photo-image-bg"
          data-bg-img="./assets/assets/images/sections-bg-images/footer-bg-1.jpg"
          data-bg-opacity=".25"
        />
        <div className="container">
          <div className="row footer-cols">
            <div className="col-12 col-md-8 col-lg-4 footer-col">
              <img
                className="footer-logo"
                loading="lazy"
                src="./assets/assets/images/logo/logo-light.png"
                alt="logo"
              />
              <div className="footer-col-content-wrapper"></div>
              <div className="form-area">
                <div className="mailchimp-form">
                  <form className="one-field-form" onSubmit={handleSubscribe}>
                    <div className="field-group">
                      <label className="email-label" htmlFor="email-input">
                        {t("footer.section1.p1")}
                      </label>
                      <input
                        className="email-input"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        name="EMAIL"
                        id="email-input"
                        placeholder="Email Address"
                        autoComplete="off"
                        required
                      />
                      <div className="cta-area">
                        <button
                          className="btn-solid subscribe-btn"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Submitting..." : "Subscribe"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* Rest of columns unchanged */}
            <div className="col-6 col-lg-2 footer-col">
              <h2 className="footer-col-title">
                {t("footer.section2.heading")}
              </h2>
              <div className="footer-col-content-wrapper">
                <ul className="footer-menu">
                  <li className="footer-menu-item">
                    <i className="bi bi-arrow-right icon" />
                    <Link className="footer-menu-link" to="/about">
                      {t("footer.section2.menu1")}
                    </Link>
                  </li>
                  <li className="footer-menu-item">
                    <i className="bi bi-arrow-right icon" />
                    <Link className="footer-menu-link" to="/startup-consulting">
                      Services
                    </Link>
                  </li>
                  <li className="footer-menu-item">
                    <i className="bi bi-arrow-right icon" />
                    <Link className="footer-menu-link" to="/platform">
                      {t("footer.section2.menu2")}
                    </Link>
                  </li>
                  <li className="footer-menu-item">
                    <i className="bi bi-arrow-right icon" />
                    <Link className="footer-menu-link" to="/leadership">
                      Leadership
                    </Link>
                  </li>
                  <li className="footer-menu-item">
                    <i className="bi bi-arrow-right icon" />
                    <Link className="footer-menu-link" to="/clients">
                      Clients
                    </Link>
                  </li>
                  {/* <li className="footer-menu-item">
                    <i className="bi bi-arrow-right icon" />
                    <Link className="footer-menu-link" to="/contact-us">
                      {t("footer.section2.menu5")}
                    </Link>
                  </li> */}
                </ul>
              </div>
            </div>
            <div className="col-6 col-lg-2 footer-col">
              <h2 className="footer-col-title">
                {t("footer.section3.heading")}
              </h2>
              <div className="footer-col-content-wrapper">
                <ul className="footer-menu">
                  <li className="footer-menu-item">
                    <i className="bi bi-arrow-right icon" />
                    <Link className="footer-menu-link" to="/insights-resources">
                      {t("footer.section2.menu4")}
                    </Link>
                  </li>
                  <li className="footer-menu-item">
                    <i className="bi bi-arrow-right icon" />
                    <Link
                      className="footer-menu-link"
                      to="/trade-intelligence-platform"
                    >
                      {t("footer.section3.menu3")}
                    </Link>
                  </li>
                  <li className="footer-menu-item">
                    <i className="bi bi-arrow-right icon" />
                    <Link
                      className="footer-menu-link"
                      to="/fdi-intelligence-plateform"
                    >
                      {t("footer.section3.menu4")}
                    </Link>
                  </li>
                  <li className="footer-menu-item">
                    <i className="bi bi-arrow-right icon" />
                    <Link className="footer-menu-link" to="/blog">
                      Blogs
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-lg-4 footer-col">
              <h2 className="footer-col-title">
                {t("footer.section4.heading")}
              </h2>
              <div className="footer-col-content-wrapper">
                <div className="contact-info-card flex item-center">
                  <i className="bi bi-envelope icon" />
                  <a
                    className="text-lowercase info"
                    href="mailto:info@incubationmasters.com"
                  >
                    info@incubationmasters.com
                  </a>
                </div>
                <div className="contact-info-card d-flex align-items-top">
                  <i className="bi bi-geo-alt icon" />
                  <div>
                    <span className="text-capitalize info">
                      E07, 8th Floor, Bansal One, Bhopal MP 462016 IN
                    </span>
                    <hr />
                    <span className="text-capitalize info">
                      G Block, Bandra Kurla Complex, Mumbai, Maharashtra 400051
                      IN
                    </span>
                    <hr />
                    <span className="text-capitalize info">
                      Sprint Street, Princeton, New Jersey 08542 US
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyrights py-4">
          <div className="container">
            <div className="row align-items-center">
              {/* Left Side: Copyright Text */}

              {/* Center: Social Icons */}
              <div className="col-12 col-lg-4 d-flex justify-content-center mb-3 mb-lg-0">
                <div className="social-icons">
                  <div className="sc-wrapper dir-row sc-size-32">
                    <ul className="sc-list d-flex list-unstyled mb-0 gap-2">
                      <li className="sc-item" title="Facebook">
                        <a
                          className="sc-link"
                          href="https://www.facebook.com/IncubationMasters/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fab fa-facebook-f sc-icon" />
                        </a>
                      </li>
                      <li className="sc-item" title="LinkedIn">
                        <a
                          className="sc-link"
                          href="https://www.linkedin.com/company/incubation-masters/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fab fa-linkedin sc-icon" />
                        </a>
                      </li>
                      <li className="sc-item" title="Instagram">
                        <a
                          className="sc-link"
                          href="https://www.instagram.com/incubationmasters/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fab fa-instagram sc-icon" />
                        </a>
                      </li>
                      <li className="sc-item" title="X">
                        <a
                          className="sc-link"
                          href="https://twitter.com/IncubationMS/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fab fa-x-twitter sc-icon" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 text-center text-lg-start mb-3 mb-lg-0">
                <p className="creadits mb-0 pl-8">
                  &copy; 2026
                  <Link className="link" to="/">
                    &nbsp;Incubation Masters IM Pvt Ltd. All rights reserved.
                  </Link>
                </p>
              </div>
              {/* Right Side: Terms & Privacy */}
              <div className="col-12 col-lg-4 text-center text-lg-end">
                <div className="terms-links">
                  <Link to="/term-of-use" className="text-decoration-none">
                    {t("footer_bottom.menu1")}
                  </Link>
                  <span className="mx-2">|</span>
                  <Link to="/privacy-policy" className="text-decoration-none">
                    {t("footer_bottom.menu2")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
